export const ALERT_SUCCESS_HEADING = 'Thank you for your feedback!'
export const ALERT_SUCCESS_BODY = 'We have received your feedback successfully.'
export const ALERT_SUCCESS_BODY_RESPONSE_REQUESTED = 'We have received your feedback and a member of our customer service team will be following up with you soon!'
export const ALERT_ERROR_HEADING = 'Oops...'
export const ALERT_ERROR_BODY = 'We\'re having some trouble submitting your feedback right now. Please try again later.'

export const BUTTON_SUBMIT_LOADING_TEXT = 'Loading...'
export const BUTTON_SUBMIT_IDLE_TEXT = 'Submit'

export const FORM_ID = 4

export const API_URL = "https://crm.sendiks.co/api/"
